'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-d7f037ee.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
var device_provider = require('./device.provider-7154f4b3.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var hqoQuestionFeedbackSent = require('./hqo-question-feedback-sent-6f2451fb.js');
var hqoQuestionBody = require('./hqo-question-body-450c99b2.js');
var hqoQuestionHeader = require('./hqo-question-header-99968053.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var ChildContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var ButtonContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n"])));
var ReportIssue = styled__default.p(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-bottom: 24px;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-bottom: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var colorStyles = {
    true: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n      border-color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n      border-color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMediumHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }),
    false: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n      border-color: ", ";\n      opacity: 0.9;\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n      border-color: ", ";\n      opacity: 0.9;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
};
var StyledButton = styled__default(button.Button)(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  margin-bottom: 12px;\n  padding: 16px;\n  border-radius: 5px;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 19px;\n  ", "\n  ", ";\n  @media screen and (min-width: ", ") {\n    max-width: 190px;\n  };\n"], ["\n  width: 100%;\n  margin-bottom: 12px;\n  padding: 16px;\n  border-radius: 5px;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 19px;\n  ", "\n  ",
    ";\n  @media screen and (min-width: ", ") {\n    max-width: 190px;\n  };\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var buttonSkippable = _a.buttonSkippable;
    return colorStyles[buttonSkippable];
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly && "\n    pointer-events: none;\n  ";
}, constants.DIMENSIONS.MEDIUM);
var HqoQuestion = function (_a) {
    var buttonCallback = _a.buttonCallback, buttonDisabled = _a.buttonDisabled, _b = _a.buttonSkippable, buttonSkippable = _b === void 0 ? false : _b, buttonText = _a.buttonText, questionText = _a.questionText, _c = _a.showFeedbackSent, showFeedbackSent = _c === void 0 ? false : _c, _d = _a.showButton, showButton = _d === void 0 ? true : _d, _e = _a.isUserGeneratedSurvey, isUserGeneratedSurvey = _e === void 0 ? false : _e, _f = _a.readOnly, readOnly = _f === void 0 ? false : _f, className = _a.className, rest = tslib_es6.__rest(_a, ["buttonCallback", "buttonDisabled", "buttonSkippable", "buttonText", "questionText", "showFeedbackSent", "showButton", "isUserGeneratedSurvey", "readOnly", "className"]);
    return (React__default.createElement(device_provider.DeviceProvider, null,
        React__default.createElement(Container, { "data-testid": "hqo-question-container", className: className },
            React__default.createElement(hqoQuestionHeader.HqoQuestionHeader, tslib_es6.__assign({}, rest)),
            React__default.createElement(ChildContainer, null,
                !showFeedbackSent
                    ? (React__default.createElement(hqoQuestionBody.HqoQuestionBody, tslib_es6.__assign({ question: questionText, isUserGeneratedSurvey: isUserGeneratedSurvey, readOnly: readOnly }, rest)))
                    : (React__default.createElement(hqoQuestionFeedbackSent.HqoQuestionFeedbackSent, { feedbackData: rest.feedbackData, questionText: questionText, isUserGeneratedSurvey: isUserGeneratedSurvey })),
                React__default.createElement(ButtonContainer, null,
                    (rest.currentStep === 1 && rest.reportIssueText && rest.reportIssueCallback)
                        && (React__default.createElement(ReportIssue, { "data-testid": "hqo-question-report", onClick: rest.reportIssueCallback }, rest.reportIssueText)),
                    showButton && (React__default.createElement(StyledButton, { onClick: buttonCallback, text: buttonText, "data-testid": "hqo-question-button", disabled: buttonDisabled, disabledStyle: "miniApp", buttonSkippable: buttonSkippable.toString(), readOnly: readOnly })))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.HqoQuestion = HqoQuestion;
